import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import OrgList from '../OrgList';
import { getOrganizations, getOrgs, mergeOrganizations, mergeOrgs } from '../contactsRequest';
import MergeIcon from '@mui/icons-material/MergeType';
import { useDispatch } from 'react-redux';
import { openSnackbar } from '../../AppSnackbar/snackbarSlice';
import ContactFuzzySearch from '../ContactFuzzySearch';
import { useQueryClient, useMutation, useQuery } from '@tanstack/react-query';

function MergeOrgsModal(props) {
  const { openMergeOrg, setOpenMergeOrg, selectedOrg, setRefreshContacts, setOpenEditOrg, category } = props;
  const [orgs, setOrgs] = useState([]);
  const [orgsToBeMerged, setOrgsToBeMerged] = useState([]);
  const [query, setQuery] = useState('');

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleClose = () => {
    setOpenMergeOrg(false);
    setOpenEditOrg(false);
  };

  const orgsQuery = useQuery({
    queryKey: ['mergeOrgs', category],
    queryFn: () => {
      if (category === 'Outlets') {
        return getOrgs();
      }
      return getOrganizations();
    },
  });

  const mergeOrgsMutation = useMutation({
    mutationFn: () => {
      if (category === 'Outlets') {
        return mergeOrgs(orgsToBeMerged, selectedOrg);
      }
      return mergeOrganizations(orgsToBeMerged, selectedOrg);
    },
    onSuccess: async (res) => {
      if (res.status === 200) {
        dispatch(openSnackbar({ severity: 'success', message: `${category.slice(0, -1)} Merge Successful!` }));
        handleClose();
        setRefreshContacts((prev) => !prev);
        await queryClient.invalidateQueries({ queryKey: ['dropdown-table'] });
      } else {
        dispatch(openSnackbar({ severity: 'error', message: `${category.slice(0, -1)} Merge Failed!` }));
      }
    },
    onError: () => {
      dispatch(openSnackbar({ severity: 'error', message: `${category.slice(0, -1)} Merge Failed!` }));
    },
  });

  const handleMerge = () => {
    mergeOrgsMutation.mutate();
  };

  useEffect(() => {
    const responseData = Array.isArray(orgsQuery.data?.data) ? orgsQuery.data.data : [];
    setOrgs(responseData);
  }, [orgsQuery.data]);

  return (
    <Dialog
      open={openMergeOrg}
      onClose={handleClose}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
      data-cy="dialog-MergeOutletsModal"
    >
      <DialogTitle>Merge Contact</DialogTitle>
      <DialogContent sx={{ overflowX: 'hidden' }}>
        <Typography variant="body1">
          {`Please select which ${category.toLowerCase().slice(0, -1)}(s) to merge into:`}
          <strong> {selectedOrg?.name}</strong>
        </Typography>
        <Typography variant="body1">
          Selected to become above:
          <strong>{orgsToBeMerged.map((contact) => contact.name).join()}</strong>
        </Typography>
        <Box
          sx={{
            marginBottom: '10px',
            marginTop: '10px',
            width: '35rem',
          }}
        >
          <ContactFuzzySearch
            contacts={orgs}
            setSearchResults={setOrgs}
            query={query}
            setQuery={setQuery}
            category={category}
            fullWidth={true}
          />
        </Box>
        <Box
          sx={{
            height: '50vh',
          }}
        >
          <OrgList
            organizations={orgs}
            isMerging={true}
            selectedOrganization={selectedOrg}
            orgsToBeMerged={orgsToBeMerged}
            setOrgsToBeMerged={setOrgsToBeMerged}
            category={category}
          />
        </Box>
        <DialogActions>
          <br></br>
          <Button onClick={handleClose} variant="contained" data-cy="cancel-button-MergeOutletsModal">
            Cancel
          </Button>
          <Button
            onClick={handleMerge}
            startIcon={<MergeIcon />}
            variant="contained"
            data-cy="merge-button-MergeOutletsModal"
          >
            Merge
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export default MergeOrgsModal;
